const genreChannelsList = ()  => {
    return [
        {"id": 3, name :"Sport"},
        {"id": 1, name  :"Cinema "},
        {"id": 6, name  :"Jeunesse "},
        {"id": 7, name  :"Infos "},
        {"id": 2, name  :"Series"},
        {"id": 4, name  :"Decouverte "},
        {"id": 5, name  :"Diversitement "},
        {"id": 9, name  :"Musique "},
        {"id": 12, name  :"Adulte "},
    ]
}

export {
    genreChannelsList
}